import { lazy } from "react";
import { enumPermisosBancolombia } from "./enumPermisosBancolombia";
/** Componente de iconos */
const AppIcons = lazy(() => import("../../../components/Base/AppIcons"));

/**
 * RecaudoEmpresarialBancolombia
 */
const RecaudoEmpresarialBancolombia = lazy(() =>
  import("./RecaudoEmpresarialBancolombia")
);
const CargarArchivos = lazy(() =>
  import("./views/CargarArchivosRecaudo/CargarArchivos")
);
const HistoricoContingencia = lazy(() =>
  import("./views/HistoricoContingenciaRecaudo/HistoricoContingencia")
);
const TransaccionesRecaudo = lazy(() =>
  import("./views/TransaccionesRecaudo/Transacciones")
);

const listPermissions = Object.values(enumPermisosBancolombia);

export const listPermissionsBancolombia = listPermissions.splice(
  listPermissions.length / 2
);

const rutasBancolombiaRecaudoEmpresarial = {
  //RecaudoEmpresarialBancolombia 
  link: "/recaudoEmpresarial/recaudoEmpresarialBancolombia",
  label: (
    <AppIcons
      Logo={"RECAUDO"}
      name="Recaudo Empresarial Bancolombia"
    />
  ),
  component: RecaudoEmpresarialBancolombia,
  permission: listPermissionsBancolombia,
  subRoutes: [
    {
      link: "/recaudoEmpresarial/recaudoEmpresarialBancolombia/CargarArchivos",
      label: <AppIcons Logo={"RECAUDO"} name="Cargue archivo contingencia Bancolombia" />,
      component: CargarArchivos,
      permission: [enumPermisosBancolombia.Recaudo_empresarial_PDP],
    },
    {
      link: "/recaudoEmpresarial/recaudoEmpresarialBancolombia/HistoricoContingencia",
      label: (
        <AppIcons Logo={"RECAUDO"} name="Histórico Contingencia" />
      ),
      component: HistoricoContingencia,
      permission: [enumPermisosBancolombia.Recaudo_empresarial_contingencia_PDP],
    },
    {
      link: "/recaudoEmpresarial/recaudoEmpresarialBancolombia/TransaccionesRecaudo",
      label: (
        <AppIcons Logo={"RECAUDO"} name="Transacciones Recaudo" />
      ),
      component: TransaccionesRecaudo,
      permission: [enumPermisosBancolombia.Recaudo_empresarial_transacciones_PDP],
    },
  ],
};

export default rutasBancolombiaRecaudoEmpresarial;
